<template>
  <div class="has-text-centered">
    <Header class="is-uppercase has-text-weight-bold" />
    <p class="is-size-4 is-uppercase has-text-primary">{{ 'Workouts' | translate }}</p>
    <p class="is-size-3 is-uppercase lh-1">{{ workouts.length }} {{ 'workouts with' | translate }}<br>5 {{ 'repetitions' | translate }}</p>
    <div class="columns is-mobile p-l-md p-r-md is-size-4 p-t-sm p-b-none">
      <div class="column is-4 has-text-left p-b-none p-l-lg">
        {{ days === 1 ? '20:32' : '24:10' }}
      </div>
      <div class="column is-4"></div>
      <div class="column is-4 has-text-right p-b-none p-r-lg">
        Level: {{ 'Leicht' }}
      </div>
    </div>
    <div v-for="(item, i) in workouts" :key="i" class="preview">
      <hr class="has-background-grey-lighter m-t-sm m-b-md">
      <p @click="begin(i)" class="is-size-4 is-uppercase has-text-left">{{ item.name }}</p>
      <Video v-on:click="begin(i)" :src="'http://assets.keepyou.fit/fitness/' + item.group + '/' + item.file" viewmode="5x3" class="shadow" :poster="'http://assets.keepyou.fit/fitness/' + item.group + '/' + item.prev" style="position:relative;">
        <img src="/../../static/svg/play-primary.svg" class="icon is-medium play" />
      </Video>
    </div>
    <div class="has-background-dark" style="position:fixed;left:0;right:0;bottom:0;">
        <div @click="begin(0)" style="margin-bottom: 50px;" class="is-fullwidth has-background-primary has-text-white has-text-centered p-sm is-size-3">
          <span v-show=" ! playing">{{ $t('Start training') }}! </span>
          <img v-show=" ! playing" src="@/../static/svg/play.svg" class="icon" style="height: 3rem;width: 3rem;margin-bottom:-0.75rem !important">
          <span v-show="playing" class="icon has-text-light is-size-2" style="height: 2.75rem;width: 2.75rem;">
            <i class="fa fa-pause"></i>
          </span>
        </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Video from '@/components/Settings/VideoM'
import Footer from '@/components/Footer'
import Header from '@/components/Header'

export default {
  name: 'Training',
  data () {
    let days = 1 + this.$store.getters.getTrainingDays % 3
    return {
      days,
      workouts: this.$store.getters.getWarmup.concat(this.$store.getters.getNWorkouts(1 + 2 * days), this.$store.getters.getCooldown)
    }
  },
  methods: {
    begin (i) {
      console.log(i)
      this.$store.commit('setWorkoutNumber', i)
      this.$router.push({ name: 'TrainingFlow' })
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    }
  },
  components: {
    Video,
    Footer,
    Header
  }
}
</script>

<style>
.preview {
  display: inline-block;
  margin: 0.5rem 1rem;
  border-radius: 0.5rem;
}
.play {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -16px;
  margin-top: -16px;
}
</style>





// WEBPACK FOOTER //
// src/components/Settings/TrainingWomen.vue